import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from "@mui/material";
import { RiArrowDownSLine } from "@remixicon/react";
import React, { useMemo } from "react";
import CompletedHistoricallySamples from "../../components/Sample/CompletedHistoricallySamples";
import { getMondayOfCurrentWeek } from "../../utils/common";

const SampleInsightsPage: React.FC = () => {
  document.title = "Executive Insights - Samples";

  const dateEnd = useMemo(getMondayOfCurrentWeek, []);

  return (
    <Box>
      <Typography
        variant="h3"
        component="h1"
        sx={{ fontSize: "2em", fontWeight: "bold", margin: "20px auto" }}
      >
        Samples Insights
      </Typography>
      <Accordion>
        <AccordionSummary
          expandIcon={<RiArrowDownSLine />}
          aria-controls="completed-stats-content"
          id="completed-stats-header"
        >
          <Typography variant="h5">Completed Samples</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <CompletedHistoricallySamples />
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default SampleInsightsPage;
